import React, {useState} from 'react';
import {Col, Row} from 'antd';
import UploadForm from "../components/UploadForm";
import {Options, Status, UploadContext} from "../context/Upload";


const Upload = () => {

    const [status, setStatus] = useState<Status>({
        dataType: false,
        destination: false,
        done: false
    })

    const [options, setOptions] = useState<Options>({
        selectedDataType: null,
        selectedDestination: null
    })

    return (
        <Row>
            <Col span={24}>
                <UploadContext.Provider value={{
                    status,
                    options,
                    setOptions,
                    setStatus
                }}>
                    <UploadForm/>
                </UploadContext.Provider>
            </Col>
        </Row>)
}

export default Upload;
